import { useMemo } from 'react';

export default () => {
    const view = useMemo(() => {
        const params = new URLSearchParams(window.location.search);
        return params.get('view') as 'payment' | 'transfer' | undefined;
    }, []);
    if (view && view !== 'payment' && view !== 'transfer') {
        return 'payment';
    }
    return view ?? 'payment';
};
